import React from "react";

const ImageReader = (props: { file: any }): JSX.Element => {
  return <img src={props.file} alt={""} height={"100%"} />;
};

export default ImageReader;
